<script setup>

import { ref, onMounted, defineEmits, defineProps, watch, computed } from "vue";
import ERP from "../../../api/v2/ERP.mjs";
import View from "../../../api/v2/View.mjs";
import UtilMoney from "../../../utils/UtilMoney";
import UtilArray from "../../../utils/UtilArray.mjs";
import UtilPDF from "../../../utils/UtilPDF";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "usuarioStore",
    "colaboradorStore",
    "pedidosDeCompra",
    "fornecedores",
    "revisandoPedido",
    "parcelasCondicoesDePagamento",
    "itensUnidades",
    "controlesDesativados"
]);

const emits = defineEmits([
    "update:pedidosDeCompra",
    "update:fornecedores",
    "update:parcelasCondicoesDePagamento",
    "update:itensUnidades",
    "update:cotacoesDePedidoDeCompra",
    "update:revisandoPedido",
    "update:controlesDesativados"
]);

//==================================================================//
//================= Altera Controles Desativados ===================//
//==================================================================//

const alteraControlesDesativados = (update)=>{

    emits('update:controlesDesativados',update);

};

//==================================================================//
//==================== Altera Revisando Pedido =====================//
//==================================================================//

const alteraRevisandoPedido = (update)=>{

    emits('update:revisandoPedido',update);

};

//==================================================================//
//==================== Altera Fornecedores =========================//
//==================================================================//

const alteraFornecedores = (update=[])=>{

    emits('update:fornecedores',update);

};

//==================================================================//
//=========== Altera Parcelas Condicoes de Pagamento ===============//
//==================================================================//

const alteraParcelasCondicoesDePagamento = (update=[])=>{

    emits('update:parcelasCondicoesDePagamento',update);

};

//==================================================================//
//=================== Altera Itens Unidades ========================//
//==================================================================//

const alteraItensUnidades = (update=[])=>{

    emits('update:itensUnidades',update);

};

//==================================================================//
//============ Altera Cotacoes De Pedido De Compra =================//
//==================================================================//

const alteraCotacoesDePedidoDeCompra = (update=[])=>{

    emits('update:cotacoesDePedidoDeCompra',update);

};

//==================================================================//
//================== Altera Pedidos de Compra ======================//
//==================================================================//

const alteraPedidosDeCompra = (update=[])=>{

    emits('update:pedidosDeCompra',update);

};

//==================================================================//
//===================== Fornecedores Carregados ====================//
//==================================================================//

const fornecedoresCarregados = computed(()=> {

    return !UtilArray.isEmpty(props.fornecedores)

});

//==================================================================//
//=========== Parcelas Condicoes de Pagamento Carregados ===========//
//==================================================================//

const parcelasCondicoesDePagamentoCarregados = computed(()=> {

    return !UtilArray.isEmpty(props.parcelasCondicoesDePagamento)

});

//==================================================================//
//==================== Itens Unidades Carregados ===================//
//==================================================================//

const itensUnidadesCarregados = computed(()=> {

    return !UtilArray.isEmpty(props.itensUnidades)

});

//==================================================================//
//==================== Pedidos de Compra Loading ===================//
//==================================================================//

const pedidosDeCompraLoading = ref(true);

//==================================================================//
//============= Altera Pedidos de Compra Loading ===================//
//==================================================================//

const alteraPedidosDeCompraLoading = (update)=>{

    pedidosDeCompraLoading.value = update

};

//==================================================================//
//==================== Busca Numero do Pedido ======================//
//==================================================================//

const buscaNumerosPedidos = computed(()=>{

    return props?.pedidosDeCompra?.map(({codigo})=>codigo);

});
let buscaNumeroPedidoSelecionado = ref("");

//==================================================================//
//======================= Busca Fornecedor =========================//
//==================================================================//

const buscaFornecedores = computed(()=>{

    return props?.pedidosDeCompra?.map(({fornecedor})=>fornecedor.nome);

});
let buscaFornecedorSelecionado = ref("");

//==================================================================//
//===================== Filter Pedidos Header ======================//
//==================================================================//

const filterNumeroDoPedido = (numeroDoPedido) =>{

    if(!buscaNumeroPedidoSelecionado.value){
        return true;
    }
    
    return numeroDoPedido.toLowerCase().includes(buscaNumeroPedidoSelecionado.value.toLowerCase());

}

const filterFornecedor = (fornecedor) =>{

    if(!buscaFornecedorSelecionado.value) {
        return true;
    }

    return fornecedor.toLowerCase().includes(buscaFornecedorSelecionado.value.toLowerCase());

}

//==================================================================//
//==================== Pedidos de Compra Header ====================//
//==================================================================//

let pedidoDeCompraHeaders = [
    { text: '',                                         value: 'revisar',                       class:"c-pedido__header",    cellClass:'c-pedido__cell'},
    { text: '',                                         value: 'pdf',                           class:"c-pedido__header",    cellClass:'c-pedido__cell'},
    { text: 'N° do Pedido',                             value: 'codigo',                        class:"c-pedido__header",    cellClass:'c-pedido__cell', filter: filterNumeroDoPedido},
    { text: 'Fornecedor',                               value: 'fornecedor.nome',               class:"c-pedido__header",    cellClass:'c-pedido__cell', filter: filterFornecedor},
    { text: 'Vendedor(a)',                              value: 'fornecedorVendedor.nome',       class:"c-pedido__header",    cellClass:'c-pedido__cell'},
    { text: 'Comprador(a)',                             value: 'comprador.nome',                class:"c-pedido__header",    cellClass:'c-pedido__cell'},
    { text: 'Total dos itens',                          value: 'precoTotalComImpostos',         class:"c-pedido__header",    cellClass:'c-pedido__cell'},
    { text: 'Total Geral (Impostos Inclusos)',          value: 'precoTotalComImpostosComIPI',   class:"c-pedido__header",    cellClass:'c-pedido__cell'},
    { text: 'Total dos Itens (Sem Impostos + IPI)',     value: 'precoTotalSemImpostosComIPI',   class:"c-pedido__header",    cellClass:'c-pedido__cell'},
    { text: 'Total do Disponivel',                      value: 'valorDisponivel',               class:"c-pedido__header",    cellClass:'c-pedido__cell'},
    { text: 'Itens',                                    value: 'itens',                         class:"c-pedido__header",    cellClass:'c-pedido__cell'},
    { text: 'Parcelas',                                 value: 'parcelas',                      class:"c-pedido__header",    cellClass:'c-pedido__cell'},
]

//==================================================================//
//===================== Load Pedidos de Compra  ====================//
//==================================================================//

const loadPedidosDeCompra = async () =>{

    alteraPedidosDeCompraLoading(true);

    const pedidosDeCompraResponse = await ERP.getManyWithView(View.PEDIDO_DE_COMPRA_REVISAO_DE_PEDIDO_DE_COMPRA,[
        {
            name: "owner",
            dataType: "String",
            value: props?.usuarioStore.usuario.id
        },
    ]);
    
    alteraPedidosDeCompra(pedidosDeCompraResponse.data)

    alteraPedidosDeCompraLoading(false);

};

//==================================================================//
//======================= Load Fornecedores ========================//
//==================================================================//

const loadFornecedores = async () =>{

    const fornecedoresResponse = await ERP.getManyWithView(View.PEDIDO_DE_COMPRA_REVISAO_DE_PEDIDO_DE_COMPRA_FORNECEDORES);
    if(fornecedoresResponse.status != 200){
        throw new Error("Falha ao obter os Fornecedores"); 
    }

    alteraFornecedores(fornecedoresResponse.data);

};

//==================================================================//
//============== Load Parcelas Condicoes De Pagamento ==============//
//==================================================================//

const loadParcelasCondicoesDePagamento = async () =>{

    const parcelasCondicoesDePagamentoResponse = await ERP.getManyWithView(View.PEDIDO_DE_COMPRA_REVISAO_DE_PEDIDO_DE_COMPRA_PARCELAS_CONDICAO_DE_PAGAMENTO);
    if(parcelasCondicoesDePagamentoResponse.status != 200){
        throw new Error("Falha as Condições de Pagamento das Parcelas"); 
    }

    alteraParcelasCondicoesDePagamento(parcelasCondicoesDePagamentoResponse.data)

};

//==================================================================//
//==================== Load Unidades dos Itens =====================//
//==================================================================//

const loadUnidadesItens = async () =>{

    const itensUnidadesResponse = await ERP.getManyWithView(View.PEDIDO_DE_COMPRA_REVISAO_DE_PEDIDO_DE_COMPRA_ORDEM_DE_SERVICO_ITENS_UNIDADES);
    if(itensUnidadesResponse.status != 200){
        throw new Error("Falha ao Carregar as Unidades dos Itens"); 
    }

    alteraItensUnidades(itensUnidadesResponse.data);

};

//==================================================================//
//================ Load Cotacoes de Pedido de Compra ===============//
//==================================================================//

const loadCotacoesDePedidoDeCompra = async () =>{

    const cotacoesDePedidoDeCompraResponse = await ERP.getManyWithView(View.PEDIDO_DE_COMPRA_REVISAO_DE_PEDIDO_DE_COMPRA_COTACOES_DE_PEDIDO_DE_COMPRA,[
        {
            name: "owner",
            dataType: "String",
            value: props?.usuarioStore.usuario.id
        },
    ]);

    alteraCotacoesDePedidoDeCompra(cotacoesDePedidoDeCompraResponse?.data||[]);

};

//==================================================================//
//================== Ao Revisar Pedido de Compra ====================//
//==================================================================//

const aoRevisarPedidoDeCompra = async (pedidoDeCompra)=>{

    alteraControlesDesativados(true);

    if(!fornecedoresCarregados.value){
        await loadFornecedores()
    }

    if(!parcelasCondicoesDePagamentoCarregados.value){
        await loadParcelasCondicoesDePagamento()
    }

    if(!itensUnidadesCarregados.value){
        await loadUnidadesItens()
    }

    await loadCotacoesDePedidoDeCompra()

    alteraControlesDesativados(false);

    alteraRevisandoPedido({
        revisandoPedido: true,
        pedidoDeCompra: pedidoDeCompra
    });

}

//==================================================================//
//============================ onMounted ===========================//
//==================================================================//

onMounted(async ()=>{

    await loadPedidosDeCompra();

});

//==================================================================//
//============================== Watch =============================//
//==================================================================//

watch(()=> props.revisandoPedido, async () => {

    if(props.revisandoPedido == false){
        await loadPedidosDeCompra();
    }

});

//==================================================================//
//===================== Download PDF do Pedido =====================//
//==================================================================//

const downloadPDFDoPedido = async (item) =>{

    await UtilPDF.downloadPDFFromAction({
        actionName: "PDF Pedido de Compra",
        documentName:`Pedido de Compra ${item.codigo}`,
        params:{
            id: item.id,
        }
    });

};

</script>

<template>

    <v-card
        class="c-lista-de-pedidos"
    >

        <v-card-title
            class="c-lista-de-pedidos__header"
        >

            <h3
                class="c-header__titulo"
            >
                Pedidos de Compra
            </h3>

            <div
                class="c-header__buscas"
            >

                <div class="c-busca c-busca--select c-busca--numero-do-pedido">

                    <v-select
                        label="N° do Pedido"
                        class="c-busca__input"
                        v-model="buscaNumeroPedidoSelecionado"
                        :items="buscaNumerosPedidos"
                        :item-props="true"
                        item-text="codigo"
                        hide-details
                        outlined
                        return-object
                        clearable
                    ></v-select>

                </div>

                <div class="c-busca c-busca--select c-busca--fornecedor">

                    <v-select
                        label="Fornecedor"
                        class="c-busca__input"
                        v-model="buscaFornecedorSelecionado"
                        :items="buscaFornecedores"
                        :item-props="true"
                        item-text="codigo"
                        hide-details
                        outlined
                        return-object
                        clearable
                    ></v-select>

                </div>

            </div>

            <v-chip
                class="c-header__comprador"
                label
            >

                <v-icon left>
                    mdi-account-circle-outline
                </v-icon>
                Comprador:
                {{colaboradorStore.colaborador.nome}}

            </v-chip>

        </v-card-title>

        <v-data-table
            class="c-lista-de-pedidos__tabela elevation-1"
            :headers="pedidoDeCompraHeaders"
            :items="props.pedidosDeCompra"
            :items-per-page="-1"
            select-strategy="all"
            item-key="id"
            return-object
            :loading="pedidosDeCompraLoading"
            loading-text="Carregando... Por favor, aguarde."
        >

            <template v-slot:item.revisar="{ item }">

                <v-tooltip bottom>

                    <template v-slot:activator="{ on, attrs }">

                        <v-btn
                            class="c-revisar-pedido mx-2"
                            fab
                            dark
                            small
                            color="primary"
                            v-bind="attrs"
                            v-on="on"
                            :disabled="props.controlesDesativados"
                            @click="aoRevisarPedidoDeCompra(item)"
                        >

                            <v-icon dark>
                                mdi-invoice-text-edit-outline
                            </v-icon>
                        
                        </v-btn>

                    </template>

                    <span>Revisar o Pedido de Compra</span>

                </v-tooltip>

            </template>

            <template v-slot:item.pdf="{ item }">

                <v-tooltip bottom>

                    <template v-slot:activator="{ on, attrs }">

                        <v-btn
                            class="c-visualizar-pedido mx-2"
                            fab
                            dark
                            small
                            color="primary"
                            v-bind="attrs"
                            v-on="on"
                            :disabled="props.controlesDesativados"
                            @click="downloadPDFDoPedido(item)"
                        >

                            <v-icon dark>
                                mdi-download
                            </v-icon>
                        
                        </v-btn>

                    </template>

                    <span>Download PDF Pedido de Compra</span>

                </v-tooltip>

            </template>

            <template v-slot:item.precoTotalComImpostos="{ item }">

                R$ {{UtilMoney.toBRL(item?.precoTotalComImpostos)}}

            </template>

            <template v-slot:item.precoTotalComImpostosComIPI="{ item }">

                R$ {{UtilMoney.toBRL(item?.precoTotalComImpostosComIPI)}}

            </template>

            <template v-slot:item.precoTotalSemImpostosComIPI="{ item }">

                R$ {{UtilMoney.toBRL(item?.precoTotalSemImpostosComIPI)}}

            </template>

            <template v-slot:item.valorDisponivel="{ item }">

                R$ {{UtilMoney.toBRL(item?.valorDisponivel)}}

            </template>

            <template v-slot:item.itens="{ item }">

                <v-chip
                    color="primary"
                    label
                >

                    <v-icon left>
                        mdi-cube-outline
                    </v-icon>
                    {{item?.itens?.length}}

                </v-chip>

            </template>

            <template v-slot:item.parcelas="{ item }">

                <v-chip
                    color="deep-orange"
                    label
                    dark
                >

                    <v-icon left>
                        mdi-cash-multiple
                    </v-icon>
                    {{item?.parcelas?.length}}

                </v-chip>

            </template>

        </v-data-table>

    </v-card>

</template>

<style scoped>

.c-lista-de-pedidos__header{
    display: grid; 
    grid-template-columns: 1fr 1fr; 
    grid-template-rows: 1fr auto; 
    grid-template-areas: 
    "titulo ."
    "buscas comprador";
    gap: 10px;
    align-items: start;
}

.c-header__titulo{
    grid-area: titulo;
}

.c-header__buscas{
    grid-area: buscas;
    display: grid; 
    grid-template-columns: 1fr 1fr; 
    grid-template-rows: 1fr; 
    gap: 10px;
    grid-template-areas: 
        "buscaNumeroDoPedido buscaFornecedor"
}

.c-busca > .c-busca__texto{
    margin: 0;
    font-size: 14px;
}

.c-busca--toogle{
    align-items: center;
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: max-content;
}

.c-busca--toogle > .c-busca__input{
    padding-left: 10px;
}

.c-busca--numero-do-pedido{
    grid-area: buscaNumeroDoPedido;
}

.c-busca--fornecedor{
    grid-area: buscaFornecedor;
}

.c-header__comprador{
    grid-area: comprador;
    margin: 0 20px;
    min-height: 48px;
}

.c-header__comprador >>> .v-chip__content{
    margin: auto;
}

.c-lista-de-pedidos__tabela{
    display: grid;
    white-space: nowrap;
}

.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg.c-revisar-pedido{
    background: #1976d2 !important;
    border-color: #1976d2 !important;
}

@media (width <= 850px) {
    
    .c-lista-de-pedidos__header{
        grid-template-columns: 1fr; 
        grid-template-rows: auto 1fr auto; 
        grid-template-areas:
            "titulo"
            "comprador"
            "buscas";
    }

    .c-header__comprador{
        margin: 0;
    }

    .c-header__buscas { 
        grid-area: buscas;
        display: grid; 
        grid-template-columns: 1fr; 
        grid-template-rows: 1fr 1fr; 
        gap: 10px; 
        grid-template-areas: 
            "buscaNumeroDoPedido"
            "buscaFornecedor";
    }

}

</style>
